<template>
  <div class="view category-items">
    <h1>{{ name }}</h1>
    <p class="description">{{ description }}</p>

    <div class="meta">
      <span class="count">{{ list.length }} {{ $tc(`general.label.${type}`, list.length) }}</span>
      <router-link :to="{name: 'availability', params: { category }}" class="calendar" v-if="type === 'activity'">{{ $t('availability.label') }}</router-link>
    </div>

    <item-list :items="list" :type="type==='product' ? 'list' : 'grid'"/>
  </div>
</template>

<script>
import Category from '@/models/Category';
import Package from '@/models/Package';
import Activity from '@/models/Activity';
import Product from '@/models/Product';
import ItemList from '@/components/ItemList';

const PAPModels = {
  package: Package,
  activity: Activity,
  product: Product
};

export default {
  components: {
    ItemList
  },

  props: {
    type: String,
    category: Number,
    date: String
  },

  created() {
    this.load();
  },

  computed: {
    categoryModel() {
      let cat = Category.find(this.category);
      return cat || (new Category());
    },

    name() {
      return this.categoryModel.name;
    },

    breadcrumbLabel() {
      return this.name;
    },

    description() {
      return this.categoryModel.description;
    },

    list() {
      return PAPModels[this.type].query().where('category', this.category).orderBy('webSortPriority', 'asc').get();
    }
  },

  watch: {
    $route() {
      this.load();
    }
  },

  methods: {
    load() {
      Category.fetch(this.type, this.category);
      PAPModels[this.type].fetchList(this.category, this.date);
    },
  }
}
</script>

<style lang="scss">
.view.category-items {
  .description {
    margin-bottom: 20px;
  }

  .meta {
    display: flex;
    margin-bottom: 18px;

    .count {
      color: $colorGray;
    }

    .calendar {
      margin-left: 18px;

      &::before {
        @include font-awesome-pseudo($fa-var-calendar-alt, light);
        margin-right: 3px;
      }
    }
  }
}
</style>